export const API_FIXED_VENTA_URL =
  // "http://127.0.0.1:5001/fixeddesarrollo-8b589/southamerica-east1/apiFixed/imprimirCFETicket";
  "https://southamerica-east1-fixedtesting-10ce2.cloudfunctions.net/apiFixed/imprimirCFETicket";

export interface ApiFixedImprimirTicket {
  apiKey: string;
  rutComercio: string;
  idCFE: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ApiFixedVentaResponse = any;

export const imprimirCFETicket = async (
  payload: ApiFixedImprimirTicket
): Promise<ApiFixedVentaResponse> => {
  const res = await fetch(API_FIXED_VENTA_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  });

  const contentType = res.headers.get("content-type") ?? "";

  const out =
    contentType.includes("application/json") || contentType.includes("json")
      ? await res.json().catch(() => null)
      : await res.text().catch(() => null);

  if (!res.ok) {
    throw new Error(out.descripcion);
  }

  return out;
};
